import { Navigate } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { PageContainer, PageHeader } from "@/components/PagePrimitives";
import { WhatsAppNotificationsCard } from "@/components/WhatsAppNotificationsCard";
import { useWhatsAppEnabled } from "@/hooks/useWhatsAppEnabled";

export function AccountNotificationsPage() {
  const { modules } = useModules();
  const whatsAppEnabled = useWhatsAppEnabled();

  // Without WhatsApp there's nothing to set, so go home (as the org settings pages do). Wait for the
  // resolved module list: the optimistic answer would fire the 403ing calls first.
  if (modules === null) return null;
  if (!whatsAppEnabled) return <Navigate to="/" replace />;

  return (
    <PageContainer size="narrow">
      <PageHeader eyebrow="Your account" title="Notifications" subtitle="How Dolfin reaches you personally." />
      <WhatsAppNotificationsCard />
    </PageContainer>
  );
}
